import { render, staticRenderFns } from "./CardStyles.vue?vue&type=template&id=764406b7&"
import script from "./CardStyles.vue?vue&type=script&lang=js&"
export * from "./CardStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports